<script lang="ts" module>
  import { Dialog } from 'bits-ui';

  import CtaButton from '@/ui/elements/buttons/CTAButton.svelte';
  import NavButton from '@/ui/elements/buttons/NavButton.svelte';
  import { useAnalysisState } from '@/utils/teo-context/teo-atoms/analysis';

  import DialogHeader from '../dialogs/cmps/DialogHeader.svelte';
  import { useDownloadReport, useGenerateReportURL } from './use-report.svelte';
</script>

<script lang="ts">
  const donwloadReport = useDownloadReport();
  const generateReportURL = useGenerateReportURL();
  let reportUrl = $state<Promise<string | null | undefined> | null>(null);

  function handleReportClick() {
    reportUrl = generateReportURL();
  }

  function handleDialogOpenChange(open: boolean) {
    if (!open) {
      reportUrl = null;
    }
  }

  const analysisState = useAnalysisState();
</script>

<NavButton
  label="Report"
  icon="Report"
  onclick={handleReportClick}
  disabled={!analysisState.current.canAnalyze}
/>

{#if reportUrl}
  {#await reportUrl}
    <!-- <Dialog.Root open onOpenChange={handleDialogOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay class="fixed inset-0 z-10 bg-white/30 backdrop-blur-xs" />
        <Dialog.Content
          preventScroll
          class="outline-hidden fixed left-1/2 top-1/2 z-50 max-h-[440px] w-[640px] translate-x-[-50%] translate-y-[-50%] rounded-md bg-white shadow-card"
        >
          <DialogHeader title="Report wird generiert..." />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root> -->
  {:then url}
    <Dialog.Root open onOpenChange={handleDialogOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay class="fixed inset-0 z-50 bg-white/30 backdrop-blur-xs" />
        <Dialog.Content
          preventScroll
          class="outline-hidden fixed left-[5vw] top-[5vh] z-50 h-[90vh] w-[90vw] rounded-md bg-white shadow-card"
        >
          <DialogHeader title="Report" />

          <iframe
            src={url}
            style="width:90vw;height:calc(100% - 128px);border-bottom:1px solid #ccc;"
            title="Report"
          ></iframe>
          <div class="fc-cc bg-plain p-4">
            <CtaButton label="Download" onclick={donwloadReport}>Download</CtaButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  {:catch error}
    <Dialog.Root open onOpenChange={handleDialogOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay class="fixed inset-0 z-50 bg-white/30 backdrop-blur-xs" />
        <Dialog.Content
          preventScroll
          class="outline-hidden fixed left-1/2 top-1/2 z-50 max-h-[440px] w-[640px] translate-x-[-50%] translate-y-[-50%] rounded-md bg-white shadow-card"
        >
          <DialogHeader title="Fehler beim Generieren des Reports" />
          <p>{String(error)}</p>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  {/await}
{/if}
